import React from 'react'
import PublicRoutes from './PublicRoutes';
import Header from '../components/website/header';
import Footer from '../components/website/footer';

const Website = () => {

    return (
        <React.Fragment>
            <Header />
            <PublicRoutes />
            <Footer />
        </React.Fragment>
    )
}

export default Website;